const useHouseFilterOptions = (data = []) => {
  const filterOptions = new Map();

  data.forEach((item) => {
    const houseValue = item.houseId;
    const houseText = item.addressHouse;

    if (!filterOptions.has(houseValue)) {
      filterOptions.set(houseValue, {
        text: houseText,
        value: houseValue,
        count: 1,
      });
    } else {
      const prevOption = filterOptions.get(houseValue);
      filterOptions.set(houseValue, {
        ...prevOption,
        count: prevOption.count + 1,
      });
    }
  });

  return Array.from(filterOptions.values()).map((option) => ({
    ...option,
    text: `${option.text} (${option.count})`,
  }));
};

export default useHouseFilterOptions;
